<span class="display-time">{{ displayTime }}</span> minutes
